import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

import { HttpService } from '@app/core/http/http.service';


@Injectable({ providedIn: 'root' })
export class ProxiesService {
    private httpService = inject(HttpService);

    private uri: string;
    constructor() {
        this.uri = environment.apiEndpoint + 'proxies';
    }

    public getData(endpoint: any, requestMethod: any, payload: any) {
      let observable: Observable<any>;

        const httpProxyRequest = {
            eventEndpoint: endpoint,
            requestMethod: requestMethod,
            payload: payload
        }
        observable = this.httpService.post(this.uri, httpProxyRequest);
        return observable;
    }
  }
